import { useApi } from 'api/useApi';
import type { UserSettings, UserSettingsModel } from 'api/user-settings/types';
import { ENV_VARS } from 'app/config/environment-vars';

const USER_SETTINGS_ERROR_KEY = 'UserSettingsApiClient';

export const useUserSettingsApi = () => {
  const fetchFunction = useApi(`${ENV_VARS.DATA_URL}/api/v1`, USER_SETTINGS_ERROR_KEY);

  const getUserSettings = () => fetchFunction<UserSettings>(`/users/settings`);

  const updateUserSettings = (model: Partial<UserSettingsModel>) =>
    fetchFunction<UserSettings>('/users/settings', {
      method: 'PUT',
      body: JSON.stringify(model)
    });

  return {
    getUserSettings,
    updateUserSettings
  };
};
